<template>
    <div>
        <van-list  @load="onLoad">
            <div v-for="item in list" :key="item.uuid">
                <table class="layout" style="padding: 20px 25px 5px 25px">
                    <tr>
                        <td colspan="2" rowspan="2" style="width:50%;">
                            <div class="header">
                                <span class="title">{{item.notificationType}}</span>
                            </div>
                        </td>
                        <td colspan="2" rowspan="2" style="text-align:right;">
                            <div>
                                <van-switch v-model="item.enable" @change="onChangeStatus(item.uuid)"/>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </van-list>
    </div>
</template>

<script>
    import {List,Toast, Switch} from 'vant';
    import userInfo from '../store/userInfo';
    import switchService from "../service/switchService";

    export default {
        data: function () {
            return {
                list: [],
            }
        },
        store: userInfo,
        components: {
            [List.name]: List,
            [Switch.name]: Switch
        },
        computed: {
            userId() {
                return this.$store.getters.getUserId;
            }
        },
        created: function () {
        },
        methods: {
            async onLoad() {
                let resp = await switchService.getList();
                this.list = resp.data.Data;
            },
            async onChangeStatus(id){
                let resp = await switchService.changeStatus(id);
                if (resp.data.Status === '1') {
                    Toast.success('操作成功!');
                } else {
                    Toast.fail(resp.data.Data);
                }
            }
        }
    };

</script>
